<script setup>
const route = useRoute();
const nuxtApp = useNuxtApp();
const props = defineProps({
  parentSeoImage: [Object, null],
});

const { getPage } = useWpApi();
const { data, error } = await getPage(route.path, nuxtApp);

if (error.value || (!isNaN(data.value?.length) && !data.value.length) || data.value?.notFound === true) {
  throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
}

const hasOwnOgOverwrite = computed(
  () => !!data.value?.yoast_head_json?.og_image
);
const schemaImage = computed(() =>
  !hasOwnOgOverwrite.value && props.parentSeoImage
    ? props.parentSeoImage.url
    : data.value?.yoast_head_json?.og_image.url
);

watch(
  () => data.value,
  (newVal) => {
    nextTick(() => {
      useWpSeo(data, schemaImage.value);
    });
  },
  { immediate: true }
);

if (!hasOwnOgOverwrite.value && props.parentSeoImage) {
  const image = props.parentSeoImage;
  useHead({
    meta: [
      { hid: "og:image", property: "og:image", content: image.url },
      { hid: "og:image-type", property: "og:image-type", content: image.type },
      {
        hid: "og:image-width",
        property: "og:image-width",
        content: image.width,
      },
      {
        hid: "og:image-height",
        property: "og:image-height",
        content: image.height,
      },
    ],
  });
}
</script>

<template>
  <div class="page media-slug-file">
    <div class="page-inner" v-if="data">
      <PageModules v-if="data?.acf" :modules="data.acf.page_modules" />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
div {
}
</style>
